/**
 * Specifies how many hours an employee works within a full week. This is important to later calculate the actual hours, missed times and salaries.
 */
export const FULL_TIME_WORKING_HOURS = 39;

/**
 * How many days per week an employee works if he is fulltime.
 * The law says 7 so we use 7 for calculations
 */
export const FULL_WORK_WEEK_DAYS = 7;
